import React from 'react';
import './BeforeAfter.css';

const projects = [
  {
    title: 'Landscape Refresh',
    subtitle: 'Front Bed Upgrade',
    beforeImage: '/images/before-after/project1-before.png',
    afterImage: '/images/before-after/project1-after.png',
    improvements: ['Planting bed reshaped','Border and grade improved', 'Site cleaned and finished']
  },
  {
    title: 'Lawn Recovery',
    subtitle: 'Curb Appeal Improvement',
    beforeImage: '/images/before-after/project2-before.png',
    afterImage: '/images/before-after/project2-after.png',
    improvements: ['Damaged turf replaced', 'Color and density restored', 'Clean edge lines established', 'Healthier overall lawn coverage']
  },
  {
    title: 'Tree Bed Renovation',
    subtitle: 'Waterside Property',
    beforeImage: '/images/before-after/project3-before.png',
    afterImage: '/images/before-after/project3-after.png',
    improvements: ['Bed area defined', 'Fresh mulch installed', 'Stone and border detail added', 'Cleaner finished appearance']
  },
  {
    title: 'Palm Feature Install',
    subtitle: 'Backyard Accent',
    beforeImage: '/images/before-after/project4-before.png',
    afterImage: '/images/before-after/project4-after.png',
    beforePosition: '50% 82%',
    afterFit: 'contain',
    afterPosition: '50% 50%',
    improvements: ['Palm planted and stabilized', 'Decorative ring added', 'Surrounding area leveled', 'Instant focal point created']
  },
  {
    title: 'Palm Replacement',
    subtitle: 'Front Bed Restoration',
    beforeImage: '/images/before-after/project5-after.png',
    duringImage: '/images/before-after/project5-during.png',
    afterImage: '/images/before-after/project5-before.png',
    improvements: ['Damaged palm removed', 'New palm installed and braced', 'Bed refreshed and cleaned', 'Front elevation restored']
  }
];

const BeforeAfter = () => {
  return (
    <section className="before-after section" id="transformations">
      <div className="container">
        <div className="section-title">
          <h2>Project Transformations</h2>
          <p>See how we turn ordinary yards into clean, professional landscapes.</p>
        </div>

        <div className="transformation-list">
          {projects.map((project) => (
            <article className="transformation-card" key={project.title}>
              <h3>
                <span>{project.title}</span> - {project.subtitle}
              </h3>

              <div className="transformation-images">
                <figure className="image-panel">
                  <span className="image-badge">Before</span>
                  <img
                    src={project.beforeImage}
                    alt={`${project.title} before`}
                    loading="lazy"
                    style={{ objectPosition: project.beforePosition || 'center' }}
                  />
                </figure>
                {project.duringImage && (
                  <figure className="image-panel">
                    <span className="image-badge">During</span>
                    <img
                      src={project.duringImage}
                      alt={`${project.title} during`}
                      loading="lazy"
                      style={{ objectPosition: project.duringPosition || 'center' }}
                    />
                  </figure>
                )}
                <figure className="image-panel">
                  <span className="image-badge">After</span>
                  <img
                    src={project.afterImage}
                    alt={`${project.title} after`}
                    loading="lazy"
                    style={{
                      objectPosition: project.afterPosition || 'center',
                      objectFit: project.afterFit || 'cover'
                    }}
                  />
                </figure>
              </div>

              <ul className="improvement-list">
                {project.improvements.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default React.memo(BeforeAfter);
